import { useLocation, useNavigate } from "react-router-dom";
import RichTextEditor from "../../components/Forms/RichTextEditor";
import { useEffect, useState } from "react";
import { challengeEditView, challengeSubmissionDetails, getChallengeSubmissionDetails, submitChallengeVerificationUpdateStatus } from "../../api/challenge";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ActionButton } from "../../components/Forms/ActionButton";
import Modal from "./components/Modal";
import { useGetAppDisplayConfig } from "../../queries/homepageOrganizer";
import { AiCarbonCard } from "../../components/AiReview/AiReviewPanel";

const SubmissionState = () => {

    const { state } = useLocation();
    const navigate = useNavigate();
    // console.log(state.submissionId);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [userData, setUserData] = useState({});
    const [submissionData, setSubmissionData] = useState({});
    const [challengeData, setChallengeData] = useState({});

    const [actualCarbonSaving, setActualCarbonSaving] = useState(0);
    const [actualCarbonSavingPoints, setActualCarbonSavingPoints] = useState(0);
    const [actualCarbonSavingCalculation, setActualCarbonSavingCalculation] = useState("");
    const [actualCarbonSavingCalculationError, setActualCarbonSavingCalculationError] = useState(false);
    const [actualCarbonSavingError, setActualCarbonSavingError] = useState(false);
    const [actualCarbonSavingPointsError, setActualCarbonSavingPointsError] = useState(false);
    const [actualCarbonSavingCalculationErrorMessage, setActualCarbonSavingCalculationErrorMessage] = useState("");
    const [actualCarbonSavingErrorMessage, setActualCarbonSavingErrorMessage] = useState("");
    const [actualCarbonSavingPointsErrorMessage, setActualCarbonSavingPointsErrorMessage] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const { data: homePageConfig, isPending: isHomePageConfigPending } = useGetAppDisplayConfig();
    
    const handleSubmit = () => {
        if (!actualCarbonSavingPoints) setActualCarbonSavingPoints(0);
        submitChallengeVerificationUpdateStatus({
            submissionData,
            userChallengeSubmissionId: state.submissionId,
            bonusPoints: submissionData?.allocatedBonusPoints,
            carbonEmissionCount: actualCarbonSaving,
            actualCarbonSavingPoints: actualCarbonSavingPoints,
            actualCarbonSavingCalculation: actualCarbonSavingCalculation,
            challengeOfTheDayPoints: challengeData?.isChallengeOfTheDay ? challengeData?.challengeOfTheDayPoints : 0,
        }, toast, navigate);
    }

    useEffect(() => {
        getChallengeSubmissionDetails(state.submissionId, setUserData, setSubmissionData, setChallengeData, toast, setLoading, setError);
    }, []);

    useEffect(() => {
        if (challengeData && submissionData) {
            if (submissionData?.actualCarbonSavingCalculation === "") {
                setActualCarbonSavingCalculation(challengeData?.carbonEmissionInfo);
            } else {
                setActualCarbonSavingCalculation(submissionData?.actualCarbonSavingCalculation);
            }
            setActualCarbonSaving(submissionData?.carbonEmissionCount);
            setActualCarbonSavingPoints(submissionData?.actualCarbonSavingPoints);
        }
    }, [challengeData, submissionData]);

    if (error) {
        return (
            <div className="w-full h-96 flex items-center justify-center">
                <h1 className="text-xl text-red font-bold">{error}</h1>
            </div>
        );
    }

    if (loading || isHomePageConfigPending) {
        return (
            <div className="w-full h-96 flex items-center justify-center">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }

    return (
        <div className="flex flex-col text-base font-medium text-gray-900 rounded mr-0">
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full p-3">
                <div className="flex justify-between items-center">
                    <h1
                        className="gap-2.5 w-full font-bold max-md:max-w-full text-primary capitalize cursor-pointer"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <span className="text-black">Submitted Challenge:</span> <span title="Challenge Category">{challengeData?.category?.name}</span> | <span title="Challenge Name">{challengeData?.name}</span> | <span title="Challenge Complexity">{challengeData.complexity}</span> | {challengeData?.inclusive ? "Inclusive Challenge" : "Not a Inclusive Challenge"}
                    </h1>
                    <div className="flex gap-2">
                        <p className="inline-flex">Status: <p className={`text-primary ml-2 font-bold`}>{"Verified"}</p></p>
                    </div>
                </div>
                <div className="mt-5 flex flex-wrap gap-5">
                    <div className="flex gap-2 basis-1/5">
                        <p className="font-semibold ">Submitted By:</p>
                        <p className="capitalize cursor-pointer text-primary font-bold">{userData?.user?.username}</p>
                    </div>
                </div>
                {
                    submissionData?.isInvited?._id && (
                        <div className="mt-5 flex flex-wrap gap-5">
                            <div className="flex gap-2 basis-1/5">
                                <p className="font-semibold ">Invited By:</p>
                                <p className="capitalize cursor-pointer text-primary font-bold">{submissionData?.isInvited?.invitedBy?.username}</p>
                            </div>
                            <div className="flex gap-2 basis-1/3">
                                <p className="font-semibold ">Invited On:</p>
                                <p className="text-primary font-bold">
                                    {new Intl.DateTimeFormat("en-IN", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        weekday: "short",
                                    }).format(new Date(submissionData?.isInvited?.createdAt))}
                                </p>
                            </div>
                        </div>
                    )
                }
            </div>
            {/* Modal for Challenge Details */}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <h2 className="text-xl font-bold mb-4">Challenge Details</h2>
                <div className="flex flex-wrap gap-5">
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Challenge Name:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.name}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Challenge Category:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.category?.name}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Challenge Idea Suggested By:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.suggestedBy?.username}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Challenge Complexity:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.complexity}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Inclusive:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.inclusive ? "Yes" : "No"}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Type Of Challenge:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.recurrent}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Challenge Submission Frequency:</p>
                        <p className="font-normal capitalize">{challengeData && '-'}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Type Of Frequency:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.typeOfFrequency ? challengeData?.typeOfFrequency : '-'}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Frequency:</p>
                        <p className="font-normal capitalize">{challengeData && challengeData?.frequency ? challengeData?.frequency : '-'}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">Start Date:</p>
                        <p className="font-normal capitalize">{challengeData && new Date(challengeData?.recurrentDuration?.startDate).toDateString()}</p>
                    </div>
                    <div className="mt-3 flex gap-2 basis-1/3">
                        <p className="font-semibold">End Date</p>
                        <p className="font-normal capitalize">{challengeData && new Date(challengeData?.recurrentDuration?.endDate).toDateString()}</p>
                    </div>
                </div>
            </Modal>
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full p-3">
                <div className="flex items-center justify-center gap-2">
                    <h2>State of Submission:</h2>
                    <h2 className="text-primary font-bold">ACCEPTED</h2>
                </div>
                <AiCarbonCard aiReview={submissionData?.aiReview} onApply={(c) => {
                    setActualCarbonSaving(c.kgRounded);
                    setActualCarbonSavingPoints(c.points);
                    setActualCarbonSavingCalculation(c.calculationHtml);
                    setActualCarbonSavingError(false);
                    setActualCarbonSavingPointsError(false);
                    setActualCarbonSavingCalculationError(false);
                }} />
                <div className="flex items-center justify-center gap-2 w-full mt-4">
                    <div className="border border-border rounded-md p-5 w-full h-full flex-1">
                        <h2 className="text-center font-bold uppercase">Carbon Saving Calculation</h2>
                        <div className="mt-5">
                            <div className="flex items-center justify-between mt-2">
                                <h2>Projected Carbon Saving:</h2>
                                <h2 className="text-primary font-bold">{challengeData && challengeData?.carbonEmissionCount || 0} KGs</h2>
                            </div>
                            <div className="flex items-center justify-between mt-2">
                                <h2>Actual Carbon Saving:</h2>
                                <div>
                                    <input
                                        type="number"
                                        name="actualCarbonSaving"
                                        id="actualCarbonSaving"
                                        className="border border-border rounded-md p-2 mr-1"
                                        value={actualCarbonSaving}
                                        min={0}
                                        onChange={(e) => {
                                            setActualCarbonSaving(e.target.value);
                                            if (e.target.value < 0) {
                                                setActualCarbonSavingError(true);
                                                setActualCarbonSavingErrorMessage("Actual Carbon Saving cannot be negative");
                                            } else {
                                                setActualCarbonSavingError(false);
                                                setActualCarbonSavingErrorMessage("");
                                                console.log(parseInt(homePageConfig.carbonSavingPointsPerKg));
                                                setActualCarbonSavingPoints((e.target.value || 0) * parseInt(homePageConfig.carbonSavingPointsPerKg));
                                            }
                                        }}
                                    /> Kg
                                    {
                                        actualCarbonSavingError && <p className="text-red text-sm">{actualCarbonSavingErrorMessage}</p>
                                    }
                                </div>
                            </div>
                            <div className="flex items-center justify-between mt-2">
                                <h2>Points to be assigned per kg:</h2>
                                <h2 className="text-primary font-bold">{homePageConfig.carbonSavingPointsPerKg}</h2>
                            </div>
                            <div className="flex items-center justify-between mt-2">
                                <h2>Actual Carbon Saving Points:</h2>
                                <div>
                                    <input
                                        type="text"
                                        name="actualCarbonSavingPoints"
                                        id="actualCarbonSavingPoints"
                                        className="border border-border rounded-md p-2 mr-1"
                                        value={actualCarbonSavingPoints}
                                        // disabled={true}
                                        onChange={(e) => {
                                            setActualCarbonSavingPoints(e.target.value);
                                            if (e.target.value < 0) {
                                                setActualCarbonSavingPointsError(true);
                                                setActualCarbonSavingPointsErrorMessage("Actual Carbon Saving Points cannot be negative");
                                            } else {
                                                setActualCarbonSavingPointsError(false);
                                                setActualCarbonSavingPointsErrorMessage("");
                                            }
                                        }}
                                    />
                                    {
                                        actualCarbonSavingPointsError && <p className="text-red text-sm">{actualCarbonSavingPointsErrorMessage}</p>
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col items-start justify-between mt-2">
                                <h2>Actual Carbon Saving Calculation:</h2>
                                <RichTextEditor
                                    name="actualCarbonSavingCalculation"
                                    readOnly={true}
                                    className="w-full h-40"
                                    placeholder="Enter your calculation here..."
                                    value={actualCarbonSavingCalculation || challengeData?.carbonEmissionInfo}
                                    onChange={(value) => {
                                        setActualCarbonSavingCalculation(value);
                                        if (value.length < 10) {
                                            setActualCarbonSavingCalculationError(true);
                                            setActualCarbonSavingCalculationErrorMessage("Actual Carbon Saving Calculation cannot be empty");
                                        } else {
                                            setActualCarbonSavingCalculationError(false);
                                            setActualCarbonSavingCalculationErrorMessage("");
                                        }
                                    }}
                                />
                                {
                                    actualCarbonSavingCalculationError && <p className="text-red text-sm">{actualCarbonSavingCalculationErrorMessage}</p>
                                }
                            </div>
                        </div>
                        <div className="mt-5 flex items-center justify-end gap-3">
                            <ActionButton
                                text="Save"
                                variant={'submit'}
                                handleSubmit={() => {
                                    if (actualCarbonSavingCalculation.length < 10) {
                                        setActualCarbonSavingCalculationError(true);
                                        setActualCarbonSavingCalculationErrorMessage("Actual Carbon Saving Calculation cannot be empty");
                                    } else {
                                        setActualCarbonSavingCalculationError(false);
                                        setActualCarbonSavingCalculationErrorMessage("");
                                    }
                                    if (actualCarbonSaving < 0) {
                                        setActualCarbonSavingError(true);
                                        setActualCarbonSavingErrorMessage("Actual Carbon Saving cannot be negative");
                                    } else {
                                        setActualCarbonSavingError(false);
                                        setActualCarbonSavingErrorMessage("");
                                    }
                                    if (actualCarbonSavingPoints < 0) {
                                        setActualCarbonSavingPointsError(true);
                                        setActualCarbonSavingPointsErrorMessage("Actual Carbon Saving Points cannot be negative");
                                    } else {
                                        setActualCarbonSavingPointsError(false);
                                        setActualCarbonSavingPointsErrorMessage("");
                                    }
                                }}
                            />
                            <ActionButton
                                text="Reset"
                                variant={'reset'}
                                handleSubmit={() => {
                                    setActualCarbonSaving(0);
                                    setActualCarbonSavingPoints(0);
                                    setActualCarbonSavingCalculation("");
                                    setActualCarbonSavingCalculationError(false);
                                    setActualCarbonSavingError(false);
                                    setActualCarbonSavingPointsError(false);
                                    setActualCarbonSavingCalculationErrorMessage("");
                                    setActualCarbonSavingErrorMessage("");
                                    setActualCarbonSavingPointsErrorMessage("");
                                }}
                            />
                        </div>
                    </div>
                    <div className="border border-border rounded-md p-5 w-full h-full flex-1">
                        <h2 className="text-center font-bold uppercase">Point Calculation</h2>
                        <h2 className="font-semibold mt-2 flex gap-2">
                            <p className="text-primary font-bold">
                                Challenge:
                            </p>
                            {challengeData?.name}</h2>
                        <div>
                            <h2 className="text-primary font-bold underline mt-2">Submission Points:</h2>
                            <div className="flex items-center justify-between mt-1">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Maximum:</h2>
                                    <h2 className="text-primary font-bold">{
                                        challengeData && challengeData?.pagesAndQuestions?.reduce((total, page) => {
                                            if (!page.isBonusPage) {
                                                return total + page.questions.reduce((sum, question) => sum + question.points, 0);
                                            }
                                            return total;
                                        }, 0)
                                    }</h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Earned:</h2>
                                    <h2 className="text-primary font-bold">{submissionData && submissionData?.allocatedPoints}</h2>
                                </div>
                            </div>

                            <h2 className="text-primary font-bold underline mt-2">Bonus Points:</h2>
                            <div className="flex items-center justify-between mt-1">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Maximum:</h2>
                                    <h2 className="text-primary font-bold">{challengeData && challengeData?.pagesAndQuestions?.reduce((total, page) => {
                                        if (page.isBonusPage) {
                                            return total + page.questions.reduce((sum, question) => sum + question.points, 0);
                                        }
                                        return total;
                                    }, 0)
                                    }</h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Earned:</h2>
                                    <h2 className="text-primary font-bold">{submissionData && submissionData?.allocatedBonusPoints || 0}</h2>
                                </div>
                            </div>

                            <h2 className="text-primary font-bold underline mt-2">Carbon Saving Points:</h2>
                            <div className="flex items-center justify-between mt-1">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Projected:</h2>
                                    <h2 className="text-primary font-bold">{challengeData && (
                                        parseFloat(challengeData?.carbonSavingPoints) || 0
                                    )}</h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Earned:</h2>
                                    <h2 className="text-primary font-bold">{actualCarbonSavingPoints}</h2>
                                </div>
                            </div>

                            <h2 className="text-primary font-bold underline mt-2">Total Points:</h2>
                            <div className="flex items-center justify-between mt-1">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Maximum:</h2>
                                    <h2 className="text-primary font-bold">{
                                        challengeData && challengeData?.pagesAndQuestions?.reduce((total, page) => {
                                            return total + page.questions.reduce((sum, question) => sum + question.points, 0);
                                        }, 0) + parseFloat(challengeData?.carbonSavingPoints || 0)
                                    }
                                    </h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Earned:</h2>
                                    <h2 className="text-primary font-bold">{
                                        // for bonus points
                                        ((submissionData?.pagesAndQuestions?.reduce((total, page) => {
                                            if (page.isBonusPage) {
                                                return total + page.questions.reduce((sum, question) => sum + question.allocatedPoints, 0);
                                            }
                                            return total;
                                        }, 0)) +
                                            // challenge points
                                            (submissionData && submissionData?.pagesAndQuestions?.reduce((total, page) => {
                                                if (!page.isBonusPage) {
                                                    return total + page.questions.reduce((sum, question) => sum + question.allocatedPoints, 0);
                                                }
                                                return total;
                                            }, 0))
                                            // carbon saving points
                                            + parseInt(actualCarbonSavingPoints || 0) || 0)
                                    }</h2>
                                </div>
                            </div>

                            <hr className="mt-3 border-border" />

                            <div className="flex items-center justify-between mt-3">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Referral:</h2>
                                    <h2 className="text-primary font-bold">{submissionData && submissionData?.isInvited ? "Yes" : "No"}</h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Points:</h2>
                                    <h2 className="text-primary font-bold">{submissionData && submissionData?.isInvited ? homePageConfig?.invitedUserToChallengePoints : 0}</h2>
                                </div>
                            </div>

                            <div className="flex items-center justify-between mt-1">
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Challenge of the Day:</h2>
                                    <h2 className="text-primary font-bold">{challengeData && challengeData?.challengeOfTheDay ? "Yes" : "No"}</h2>
                                </div>
                                <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Points:</h2>
                                    <h2 className="text-primary font-bold">{challengeData && challengeData?.challengeOfTheDay ? challengeData?.challengeOfTheDayPoints : 0}</h2>
                                </div>
                            </div>

                            <div className="flex items-center justify-between mt-1">
                            <div className="flex items-start gap-1 basis-1/2">
                                <h2>Sponsored:</h2>
                                <h2 className="text-primary font-bold">{challengeData && challengeData?.isSponsored ? "Yes" : "No"}</h2>
                            </div>
                                {/* <div className="flex items-start gap-1 basis-1/2">
                                    <h2>Points:</h2>
                                    <h2 className="text-primary font-bold">{challengeData && challengeData?.challengeOfTheDay ? challengeData?.challengeOfTheDayPoints : 0}</h2>
                                </div> */}
                            </div>

                        </div>
                    </div>
                </div>
                <div className="mt-5 flex items-center justify-end gap-3">
                    <ActionButton
                        text="Cancel"
                        variant={'cancel'}
                        handleSubmit={() => {
                            navigate('/submissions/challenge-submission');
                        }}
                    />
                    <ActionButton
                        text="Submit"
                        variant={'submit'}
                        handleSubmit={() => {
                            handleSubmit();
                        }}
                    />
                </div>
            </div>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
}

export default SubmissionState;
